/* eslint react/jsx-filename-extension: "off" */

import React from "react";
// import moment from "moment";
import _ from "underscore";

import styled from "styled-components";
import vars from "@exo/narrative-tracker-variables";

import { formatPosition } from "@exo/helpers";
import { pickIcon } from "@exo/icons";
import { lookupTags } from "lib/helpers/contentTabHelpers.js";
// import { IconBox } from "lib/tableTransforms";

export const pickDarkOrLightIcon = (params) => {
	const { cell, context, row } = params;
	return pickIcon({ type: cell, color: context.darkUI ? vars.sky_2 : vars.grey_3 });
};

// ------- tagTransform ------
const TitleSpan = styled.span`
	margin-right: 10px;
	line-height: 130%;
`;
const TagBox = styled.span`
	display: inline-block;
	padding-right: 2px;
	text-align: left;
`;
const Tag = styled.span`
	display: inline-block;
	position: relative;
	height: 10px;
	width: ${(props) => (props.colorBlindMode ? 40 : 10)}px;
	margin: 0 4px;
	background-color: ${(props) => props.bgColor};
	border-radius: ${(props) => (props.location ? "2px" : "50%")};
	border: 1px solid ${(props) => (props.darkUI ? vars.charcoal_1 : vars.grey_2)};
	z-index: 1;
	transition: width 350ms ease-out 50ms;
	&:hover {
		span {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}
`;

export const tagTransform = (params) => {
	const { cell, row, context } = params;
	const tags = lookupTags({ tagLibrary: context.tagLibrary, idList: row.tags });
	return (
		<span>
			<TitleSpan dangerouslySetInnerHTML={{ __html: cell }} />
			<TagBox>
				{tags &&
					tags.map((tag) => {
						const bgColor = tag.color ? (context.darkUI ? tag.color.dark : tag.color.light) : "transparent";
						return (
							<Tag
								key={`contentLink__tag-${row.uuid || row.id}-${tag.id}`}
								bgColor={bgColor}
								className={tag.color && (tag.color.colorblind || tag.color.colorblindstripes)}
								colorBlindMode={context.colorBlindMode}
								darkUI={context.darkUI}
								location={tag.location}
								onMouseEnter={(event) =>
									context.openTooltip({
										position: formatPosition(event.target),
										text: tag.name,
										color: bgColor,
									})
								}
								onMouseLeave={() => context.closeTooltip()}
							/>
						);
					})}
			</TagBox>
		</span>
	);
};
